export enum ClockName {
    DEFAULT = "DEFAULT",
    WARM_UP = "WARM_UP",
    SET_TIME = "SET_TIME",
    SET_BREAK = "SET_BREAK",
    GAME_BREAK = "GAME_BREAK",
    POINT_BREAK = "POINT_BREAK",
    MEDICAL_TIMEOUT = "MEDICAL_TIMEOUT",
    TIMEOUT = "TIMEOUT"
}